const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.PURELEI.Carousel.plugins

const { getElement } = window.PURELEI.Utils

class ComplementaryProductsCarousel extends window.PURELEI.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.triggers?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
      this.listeners.add(triggerEl, 'touchstart', this.handleTrigger)
    })
  }

  setupCarousel () {
    if (!this.els.slide) return
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
        },
      },
      [
        setInitialised(),
        /*useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),*/
      ],
    )
  }

  handleTrigger (e) {
    const productHandle = e.currentTarget.dataset.productHandle ?? null

    if (!productHandle) return

    const trigger = e.currentTarget
    const drawerKey = trigger.getAttribute('data-drawers-trigger')

    if (drawerKey && getElement('site-popup-drawer') != null) {
      const currentPopupDrawer = getElement('site-popup-drawer')
      if (drawerKey === currentPopupDrawer.getAttribute('key')) {
        currentPopupDrawer.init()
        return
      }
    }

    fetch(`/products/${productHandle}?section_id=complementary-product-popup`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const productPopupComponent = getElement('site-popup-drawer', {
          context: html,
        })

        if (productPopupComponent) {
          if (getElement('site-popup-drawer')) {
            getElement('site-popup-drawer').remove()
          }
          document.body.appendChild(productPopupComponent)
        }
      })
      .catch((error) => {
        console.error('Error loading product section:', error)
      })
  }

  get triggers () {
    return this.els.trigger
  }

  get config () {
    return {
      elements: {
        trigger: 'cpl-Card_Trigger',
      },
    }
  }
}

if (!customElements.get('complementary-products-carousel')) {
  customElements.define(
    'complementary-products-carousel',
    ComplementaryProductsCarousel,
  )
}
